import { create } from 'zustand';

export const useSurveyResponsesStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    selectedItem: null,
    detailLoading: false,
    isDetailOpen: false,

    paginationData: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 15,
        hasNextPage: false,
        hasPreviousPage: false,
    },

    searchParams: {
        page: 1,
        pageSize: 15,
        searchTerm: '',
        sortBy: 'submittedAt',
        sortDirection: 'desc',
    },
    columnFilters: {},
    uniqueValues: {},

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
    setSearchParams: (params) =>
        set((state) => ({
            searchParams: { ...state.searchParams, ...params },
        })),
    setColumnFilters: (filters) => set({ columnFilters: filters }),

    setSearchTerm: (searchTerm) =>
        set((state) => ({
            searchParams: { ...state.searchParams, searchTerm, page: 1 },
        })),
    setSorting: (sortBy, sortDirection) =>
        set((state) => ({
            searchParams: { ...state.searchParams, sortBy, sortDirection },
        })),
    setCurrentPage: (page) =>
        set((state) => ({
            searchParams: { ...state.searchParams, page },
        })),
    setPageSize: (pageSize) =>
        set((state) => ({
            searchParams: { ...state.searchParams, pageSize, page: 1 },
        })),

    openDetail: (item) => set({ isDetailOpen: true, selectedItem: item }),
    closeDetail: () => set({ isDetailOpen: false, selectedItem: null, detailLoading: false }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setDetailLoading: (detailLoading) => set({ detailLoading }),
}));
